import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/nl';
export const locale = {
  lang: 'nl',
  data: {
    'VOICE': {
      'ENABLE': 'Schakel audiotracks in om te onderzoeken',
      'TITULO': 'Spraakinstellingen',
      'SUBTITULO': 'Deze instelling wordt alleen toegepast als de audiotracks voor de meting zijn ingeschakeld.',
      'CONFIG_IDIOMA': {
        'TITULO': 'Huidige instellingen voor deze taal',
        'GENERO': {
          'TITULO': 'Stem geslacht',
          'Femenino': 'Vrouwelijk',
          'Masculino': 'Mannelijk'
        },
        'TIPO_VOZ': {
          'TITULO': 'Type stem',
          '1': 'Stemtype 1',
          '2': 'Stemtype 2',
          '3': 'Stemtype 3',
          '4': 'Stemtype 4',
          '5': 'Stemtype 5',
          '6': 'Stemtype 6',
          '7': 'Stemtype 7',
          '8': 'Stemtype 8',
          '9': 'Stemtype 9',
          '10': 'Stemtype 10',
        },
        'PRUEBA_VOZ': {
          'TITULO': 'Stemtest',
          'INSTRUCCION': 'Schrijf een tekst om de stem te testen',
          'PLACEHOLDER': 'Stemtest tekst',
          'PROBAR': 'Test tekst naar spraak'
        }
      },
      'MODALES': {
        'COMPLETAR': 'Weet u zeker dat u de stap voltooit met de huidige voiceselectie?',
        'COMPLETAR_OFF': 'Weet u zeker dat u de stap wilt voltooien met de spraakinstellingen uitgeschakeld?',
        'INCOMPLETO': 'U heeft nog niet de volledige selectie van stemmen in alle talen gemaakt, u moet deze voltooien om door te gaan',
        'PASO_COMPLETO': 'Stap succesvol afgerond',
        'GENERANDO_AUDIOS': 'Spraakinstellingen worden toegepast op delen van dit product, een ogenblik geduld aub'
      }
    }
  }
};
